import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { ServiceResponseData } from "../ServiceResponseData";

const ENDPOINT = "/organizations/editOrganizationProfiles";

export class EditOrganizationProfilesCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    data: EditOrganizationProfilesReqData;

    constructor(data: EditOrganizationProfilesReqData) {
        super();
        this.data = data;
    }

    public async execute(): Promise<ServiceResponseData> {
        var res = await this.executeCommand(this.data);
        return new ServiceResponseData(res);
    }
}

export class EditOrganizationProfilesReqData {
    folderId: number;
    profileNames: string[];

    constructor(profileNames: string[], folderId: number) {
        this.profileNames = profileNames;
        this.folderId = folderId;
    }
}
